module.exports = __webpack_public_path__ + "static/38-Ericsson-9bedb1b8eaa3252db14c2e950a13217d.png";